import { Card, CardContent, Typography, useTheme } from "@mui/material";
import React from "react";

import ProcedureFilter from "components/pages/dashboard/surgery_types_procedures/filter/ProcedureFilter";
import ProcedureTabs from "components/pages/dashboard/surgery_types_procedures/procedures/ProcedureTabs";

const SurgicalProcedure = () => {
  const theme = useTheme();

  return (
    <Card
      elevation={0}
      sx={{
        border: `1px solid ${theme.palette.border.main}`,
        borderRadius: "4px",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          align="center"
          sx={{ fontSize: "1.125rem", fontWeight: 500, mb: 1 }}
        >
          Care Planning Look-up Tool
        </Typography>
        <Typography
          variant="h6"
          align="center"
          sx={{
            fontSize: "1rem",
            fontWeight: 400,
            mb: 3,
            color: theme.palette.text.secondary,
          }}
        >
          Select a clinical category and configure parameters below to query
          stratified patient populations and export clinical reports.
        </Typography>

        <ProcedureTabs />
        <ProcedureFilter />
      </CardContent>
    </Card>
  );
};

export default SurgicalProcedure;
